module.exports = (__webpack_require__("G5yn"))("fogu");